import { Field } from 'formik'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { CheckboxField } from '../../field'

interface Props {
  name: string
  label?: string
  required?: boolean
  disabled?: boolean
  margin?: string
}

export const CheckboxInput: React.FunctionComponent<Props> = ({ name, label, disabled, required, margin }) => {
  const intl = useIntl()
  const validate = useCallback(
    (value: boolean): string | undefined => {
      if (required && !value) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }
      return undefined
    },
    [required, intl]
  )

  return (
    <Field
      component={CheckboxField}
      id={name}
      name={name}
      label={label}
      required={required}
      validate={validate}
      disabled={disabled}
      margin={margin}
    />
  )
}
